import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchBanks } from "../../banks/model/actions.js";
import { getLimitsFinancialProgramsLimitsGet, getPaymentsFinancialProgramsPaymentsGet } from "../../../shared/api/services.gen.js";
import { createAppApi } from "../../../shared/lib/store/createAppApi.js";
import ApiService from "../../../shared/services/ApiService.js";
import { name } from "../config/name.js";
import { formatFinancialPrograms } from "../lib/formatFinancialPrograms.js";
const api = createAppApi({
  reducerPath: name,
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getFinancialPrograms: builder.query({
      queryFn: async (query, api2) => {
        const state = api2.getState();
        const { clientId } = state.config;
        const apiClient = ApiService.getInstance().client;
        const { data: payments } = await getPaymentsFinancialProgramsPaymentsGet({
          client: apiClient,
          headers: {
            "X-Client-Id": clientId
          },
          query
        });
        if (!payments) {
          throw new Error("Ошибка, не удалось получить финансовые программы!");
        }
        const bankIds = payments.map((program) => program.bank);
        const banks = await api2.dispatch(fetchBanks(bankIds)).unwrap();
        const extFinancialPrograms = formatFinancialPrograms(payments, banks);
        return { data: extFinancialPrograms };
      }
    }),
    getCreditLimits: builder.query({
      queryFn: async (query, api2) => {
        const state = api2.getState();
        const { clientId } = state.config;
        const apiClient = ApiService.getInstance().client;
        const { data: creditLimits } = await getLimitsFinancialProgramsLimitsGet({
          client: apiClient,
          headers: {
            "X-Client-Id": clientId
          },
          query
        });
        if (!creditLimits) {
          throw new Error("Ошибка, не удалось получить кредитные лимиты!");
        }
        return { data: creditLimits };
      }
    })
  })
});
const { useGetFinancialProgramsQuery, useGetCreditLimitsQuery } = api;
export {
  api,
  useGetCreditLimitsQuery,
  useGetFinancialProgramsQuery
};
